<template lang="pug">
.login-container
  .login
    Head
    Form
</template>

<script>
import Head from "./Head";
import Form from "./Form/index";

export default {
  components: { Head, Form },
  metaInfo() {
    const app_name = process.env.VUE_APP_NAME || "Selflane";
    const title = app_name + ": Login";
    const description =
      app_name == "Selflane Business"
        ? "Login to Selflane Business to manage your restaurant."
        : "Login to Selflane to access hundreds of restaurants and order food online.";
    return {
      title,
      meta: [{ name: "description", content: description }],
    };
  },
};
</script>

<style lang="sass" scoped>
.login-container
  display: flex
  flex-flow: column
  justify-content: center
  align-items: center
  margin-top: 100px
  margin-bottom: 100px

.login
  width: 95%
  max-width: 390px
</style>
